import { render, staticRenderFns } from "./teamWithdrawals.vue?vue&type=template&id=fb02c01e&scoped=true&"
import script from "./teamWithdrawals.vue?vue&type=script&lang=js&"
export * from "./teamWithdrawals.vue?vue&type=script&lang=js&"
import style0 from "./teamWithdrawals.vue?vue&type=style&index=0&id=fb02c01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb02c01e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb02c01e')) {
      api.createRecord('fb02c01e', component.options)
    } else {
      api.reload('fb02c01e', component.options)
    }
    module.hot.accept("./teamWithdrawals.vue?vue&type=template&id=fb02c01e&scoped=true&", function () {
      api.rerender('fb02c01e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/wallet/teamWithdrawals.vue"
export default component.exports